import { ModalProps, Modal } from '../../../../../../../components/modal/modal';
import s from './shifts-controls-schedule-modal.module.css';
import { useShiftsControlsScheduleModal } from './use-shifts-controls-schedule-modal';
import { Stepper } from '../../../../../../../components/stepper/stepper';
import { Button } from '../../../../../../../components/button/button';
import { ShiftsControlsScheduleModalStep1 } from './shifts-controls-schedule-modal-step-1/shifts-controls-schedule-modal-step-1';
import { ShiftsControlsScheduleModalStep2 } from './shifts-controls-schedule-modal-step-2/shifts-controls-schedule-modal-step-2';
import { ShiftsControlsScheduleModalStep0 } from './shifts-controls-schedule-modal-step-0/shifts-controls-schedule-modal-step-0';

const steps = [
  <ShiftsControlsScheduleModalStep1 />,
  <ShiftsControlsScheduleModalStep0 />,
  <ShiftsControlsScheduleModalStep2 />,
];

export const ShiftsControlsScheduleModal = (props: ModalProps) => {
  const { t, isLoading, handleNext, handlePrev, step } = useShiftsControlsScheduleModal(props);

  return (
    <Modal {...props} title={t('Добавить расписание')} className={s.feature}>
      <Stepper current={step} totalSteps={steps.length} />
      {steps[step]}
      <div className={s.controls}>
        <Button variant="secondary" onClick={handlePrev} disabled={isLoading}>
          {t(step === 0 ? 'Закрыть' : 'Назад')}
        </Button>
        <Button onClick={handleNext} disabled={isLoading}>
          {t(step === steps.length ? 'Создать' : 'Далее')}
        </Button>
      </div>
    </Modal>
  );
};
